import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgStackedCombinedBar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M-0.00146484 47.4814H18.5786V58.877C18.5786 61.7046 16.2863 63.9968 13.4587 63.9968H5.11837C2.29077 63.9968 -0.00146484 61.7046 -0.00146484 58.877V47.4814Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.417 52.9862H63.9971V58.8767C63.9971 61.7043 61.7048 63.9965 58.8772 63.9965H50.5369C47.7093 63.9965 45.417 61.7043 45.417 58.8767V52.9862Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M-0.00146484 36.0858C-0.00146484 33.2582 2.29076 30.966 5.11837 30.966H13.4587C16.2863 30.966 18.5786 33.2582 18.5786 36.0858V39.2237H-0.00146484V36.0858Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.417 44.3434C45.417 41.5158 47.7093 39.2236 50.5369 39.2236H58.8772C61.7048 39.2236 63.9971 41.5158 63.9971 44.3434V45.4168H45.417V44.3434Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M-0.00146484 39.2237H18.5786V47.4814H-0.00146484V39.2237Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.417 45.4168H63.9971V53.6745H45.417V45.4168Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7078 44.7293H41.2878V58.8775C41.2878 61.7051 38.9956 63.9973 36.168 63.9973H27.8276C25 63.9973 22.7078 61.7051 22.7078 58.8775V44.7293Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7075 27.8286C22.7075 25.001 24.9997 22.7088 27.8273 22.7088H36.1677C38.9953 22.7088 41.2875 25.001 41.2875 27.8286V32.3428H22.7075V27.8286Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7075 32.3428H41.2875L41.2878 44.7293H22.7078L22.7075 32.3428Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36.4538 10.0707C37.2483 8.96433 37.7043 7.59417 37.6164 6.11667C37.406 2.58028 34.367 0.0634703 30.9335 0.169942C27.623 0.272599 24.8572 2.70525 24.6539 6.11651C24.5999 7.02199 24.7456 7.89009 25.0493 8.68247L13.0833 16.8411C11.8486 15.6104 10.1453 14.8496 8.26421 14.8496C4.49407 14.8496 1.43777 17.9059 1.43777 21.676C1.43777 25.4462 4.49407 28.5025 8.26421 28.5025C12.0344 28.5025 15.0907 25.4462 15.0907 21.676C15.0907 20.7089 14.8896 19.7888 14.5269 18.9552L26.4337 10.8369C27.5802 12.0128 29.1786 12.7609 30.9333 12.8155C32.2633 12.8569 33.525 12.4821 34.5846 11.82L48.1218 25.9726C47.3246 27.0896 46.8556 28.4569 46.8556 29.9338C46.8556 33.704 49.9119 36.7603 53.6821 36.7603C57.4522 36.7603 60.5085 33.704 60.5085 29.9338C60.5085 26.1637 57.4522 23.1074 53.6821 23.1074C52.3139 23.1074 51.0398 23.5099 49.9716 24.2029L36.4538 10.0707Z",
			fill: "#60A5FA"
		})
	]
});
export default SvgStackedCombinedBar;
